export function deepEqual<T>(a: T, b: T): boolean {
  if (a === b) return true;

  if (typeof a !== typeof b) return false;

  if (a && b && typeof a === 'object') {
    const isArrayA = Array.isArray(a);
    const isArrayB = Array.isArray(b);

    if (isArrayA !== isArrayB) return false;

    if (isArrayA && isArrayB) {
      const arrA = a as unknown[];
      const arrB = b as unknown[];

      if (arrA.length !== arrB.length) return false;

      const used = new Array(arrB.length).fill(false);

      for (const itemA of arrA) {
        let found = false;
        for (let i = 0; i < arrB.length; i++) {
          if (!used[i] && deepEqual(itemA, arrB[i])) {
            used[i] = true;
            found = true;
            break;
          }
        }
        if (!found) return false;
      }

      return true;
    }

    const keysA = Object.keys(a as object);
    const keysB = Object.keys(b as object);

    if (keysA.length !== keysB.length) return false;

    for (const key of keysA) {
      if (!keysB.includes(key)) return false;
      if (!deepEqual((a as Record<string, unknown>)[key], (b as Record<string, unknown>)[key])) {
        return false;
      }
    }

    return true;
  }

  return false;
}

export function deepClone<T>(value: T): T {
  if (value === null || typeof value !== 'object') {
    return value;
  }

  if (Array.isArray(value)) {
    return value.map((item) => deepClone(item)) as unknown as T;
  }

  if (value instanceof Date) {
    return new Date(value.getTime()) as unknown as T;
  }

  const clonedObj: Record<string, unknown> = {};
  for (const key of Object.keys(value)) {
    clonedObj[key] = deepClone((value as Record<string, unknown>)[key]);
  }

  return clonedObj as T;
}
